export default __webpack_public_path__ + "static/media/huiyuan.0ee89b49.png";